import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Service
import { GroupEditService } from '../../service/group-edit/group-edit.service';

@Component({
	selector: 'app-group-edit',
	templateUrl: './group-edit.component.html',
	providers: [
		GroupEditService,
		HttpModule
	]
})
export class GroupEditComponent implements OnInit {
	public editGroup: any[] = [];
	guid: string;

	private sub: any;
	private token = "";
	public groupDetails: any[] = [];
	public groupDetailsPermissions: any[];
	public groupOtherPermission: any[];
	public masterPermissions: any[] = [];
	public permissoes: any[] = [];

	constructor(private fb: FormBuilder, private router: Router, private flashMessagesService: FlashMessagesService, private groupEditService: GroupEditService, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.guid = params['guid']; // (+) converts string 'id' to a number

			this.groupEditService.getGroupDetails(this.token, this.guid).subscribe(result => {

				this.groupDetails = result.Result;
				this.groupDetailsPermissions = result.Result.Permissoes;

				if (result.Success == true) {
					this.groupEditService.getOtherPermissions(this.token).subscribe(result => {
						this.groupOtherPermission = result.Result;

						for (var i = this.groupOtherPermission.length - 1; i >= 0; i--) {

							for (var j = this.groupDetailsPermissions.length - 1; j >= 0; j--) {

								if (this.groupOtherPermission[i].Nome == this.groupDetailsPermissions[j].Nome) {
									this.groupOtherPermission[i].checked = true;
								}
							}
						}
					});
				}

			}, error => {
				console.log(error);

			});
		});
	}

	processesList() {

		if (!this.groupOtherPermission) return [];

		var processes = this.groupOtherPermission.map(p => p.Processo);
		var uniqueProcesses = processes.filter((x, i, a) => x && a.indexOf(x) === i);

		return uniqueProcesses;

	}

	permissionsByProcess(process) {

		var permissions = this.groupOtherPermission.filter(mp => mp.Processo == process);
		return permissions;

	}

	saveEditGroup(groupDetails) {

		var objEditGroup = {
			ID: groupDetails.ID,
			Nome: groupDetails.Nome,
			Ativo: groupDetails.Ativo,
			Permissoes: []
		};

		var ListGroups = this.groupOtherPermission.filter(opt => opt.checked).map(opt => opt.Nome);
		for (let obj of ListGroups) {
			objEditGroup.Permissoes.push({ Nome: obj.toString(), Ativo: true })
		}

		this.groupEditService.saveGroup(this.token, objEditGroup).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Grupo de Usuário editado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/grupo-usuario');
			}

		}, error => {
			console.log(error);
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/grupo-usuario');
	}

}



// WEBPACK FOOTER //
// ./src/app/group/component/group-edit/group-edit.component.ts